import CreateInventoryContent from "../../content/inventory/createInventory";
import { Layout } from "../../layout/page";

export function CreatedInventoryInput() {
  return (
    <Layout>
      <CreateInventoryContent />
    </Layout>
  );
}
